import { LogoMark } from "./Logo";

const WORDS = ["Origin", "Soul", "Shape", "Matter", "Stone", "Fractal", "Silence", "Time"];

const Row = ({ hidden }) => (
  <div className="marquee-row" aria-hidden={hidden}>
    {WORDS.map((w) => (
      <span key={w} className="flex items-center gap-10 md:gap-16 pr-10 md:pr-16">
        <span className="font-serif italic font-light text-4xl md:t ext-7xl text-bone/80 whitespace-nowrap">{w}</span>
        <LogoMark className="w-5 h-5 md:w-7 md:h-7 text-sand/60 shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="py-16 md:py-24 border-y border-bone/10 overflow-hidden bg-slate" data-testid="editorial-marquee">
    <div className="marquee-track">
      <Row />
      <Row hidden />
    </div>
  </section>
);
